<div class="container">
  <div
    class="modal fade"
    [id]="id"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    #modal
  >
    <div class="modal-dialog  {{ sizeModal }}">
      <div class="modal-content">
        <div class="bg-info">
          <div class="modal-header">
            <h5 class="modal-title text-white">{{ titleModal }}</h5>
            <ng-content></ng-content>
            <button
              *ngIf="!hideCloseButton"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              (click)="emitirEventoFechar()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
